import { useTheme as useEmTheme } from "@emotion/react";
import { UiModuleTheme, ThemeType } from "../theme";
import darkTheme from "../theme/dark-theme";
import lightTheme from "../theme/light-theme";

const useTheme = (themeType?: ThemeType): UiModuleTheme => {
  let theme = useEmTheme();

  if (themeType === ThemeType.DARK) theme = darkTheme;
  else if (themeType === ThemeType.LIGHT) theme = lightTheme;

  return theme;
};

export default useTheme;
